import React from "react";

type Props = {};

const Banner2: React.FC<Props> = () => {
  return (
    <section
      className="relative w-full min-h-screen bg-center bg-cover bg-no-repeat flex items-center justify-center md:justify-start md:items-start"
      style={{
        backgroundImage: `url('/bannerImgSection.jpg')`,
      }}
    >
      {/* Content */}
      <div className="relative z-10 text-center mt-16 h-full md:text-left px-6 pt-16 md:pt-32 md:pl-16 max-w-[90vw] ">
        <h1 className="text-5xl md:text-[5vw] font-black uppercase leading-tight">
          <span className="block bg-gradient-to-r from-orange-400 via-yellow-500 to-orange-500 text-transparent bg-clip-text animate-fadeInUp">
            Explore
          </span>
          <span className="block bg-gradient-to-r from-orange-500 via-red-400 to-yellow-500 text-transparent bg-clip-text animate-fadeInUp animation-delay-200">
            Experience
          </span>
          <span className="block bg-gradient-to-r from-yellow-500 via-orange-400 to-red-400 text-transparent bg-clip-text animate-fadeInUp animation-delay-400">
            Expand
          </span>
        </h1>
      </div>
    </section>
  );
};

export default Banner2;
